<div class="p-4">
    <div [innerHtml]="description">

    </div>
    <div class="d-flex flex-column mt-4">
        <button (click)="Close()" class="btn transparent-button ml-auto">Cancel</button>
    </div>
</div>